jQuery(document).ready(function($) {

  var filter_data = [];
  function updateURLHash(searchParams, col) {
    if (searchParams != '') {
      history.pushState(searchParams, '', window.location.pathname+'?'+(searchParams));
    } else {
      history.pushState(searchParams, '', col);
    }
  }

  function colorActive(color) {
    console.log(color);
    if (color != '') {
      $('.product-item').each(function(i, v) {
        if ($(v).find('[data-tag="'+color+'"]').length) {
          $(v).find('[data-tag="'+color+'"]').trigger('click');
        }
      });
    }
  }
  
  function getCollection(name, value, color) {
    if ($('.ajax_products').length){
      $.get(name+'/'+value, function(data) {
        var collection = $(data).find('#CollectionLoop').html();
        if (typeof collection !== "undefined") {
          $('#CollectionLoop').html(collection);
        } else {
          $('#CollectionLoop').html('<div class="no-results product_quck" data-col_url="'+name+'"><p><strong>Sorry, there are no products here.</strong></p></div>');
        }
        colorActive(color);
      });
    }
  }

  
  if (window.location.href.indexOf('?') > -1) {
    var load_url = [];
    var url_data = window.location.href.split('?')[1];
    var final_data = url_data.split('&');
    var color = '';
    filter_data = final_data;
    $(final_data).each(function(i,v) {
     var urlName = v.split('=')[0];
      
      if (urlName == 'Metal' || urlName == 'Type') {
        var value = v.split('=')[1];
        load_url.push(value);
        $('[data-tag_handlize="'+value+'"]').parent('li').addClass('active');
      }
    });
    var load_updateUrl = load_url.join('+');
    var collection = window.location.href.split('?')[0].split('/').slice(-1)[0];
    $(final_data).each(function(i, v) {
      if (v.indexOf('Metal') > -1) {
        color = v.split('=')[1];
      }
    });
    if (window.location.href.indexOf('Metal') == -1) {
      color = '';
    }
    if ((window.location.href.indexOf('Metal') > -1) || (window.location.href.indexOf('Type') > -1)) {
      getCollection(collection, load_updateUrl, color);
    }
  }

  $('body').on('click', '.right_inner_cols a',function(e){
    e.preventDefault();
    if (!$(this).closest('li').hasClass('active')) {
    } else {
      $(this).closest('li').removeClass('active');
    }
    var url = []
    var collection = $(this).parents('.right_cols').data('collection');
    var link = $(this).attr('href');
    var href = window.location.href;
    var group = $(this).data('group');
    var tag = $(this).data('tag_handlize');
    var searchParams = group+'='+tag;
    var color = '';
    if (filter_data.indexOf(searchParams) == -1) {
      if (window.location.href.indexOf('Metal') > -1 && group == 'Metal') {
        $('.single_select li').removeClass('active');
        $(filter_data).each(function(i, v) {
          if (v.indexOf('Metal') > -1) {
            filter_data = filter_data.filter(item => item !== v);
          }
        });
        filter_data.push(searchParams);
        if (!$(this).closest('li').hasClass('active')) {
          $(this).closest('li').addClass('active');
        }
      } else {
        if (!$(this).closest('li').hasClass('active')) {
          $(this).closest('li').addClass('active');
        }
        color = tag;
        filter_data.push(searchParams);
      }
    } else {
      filter_data = filter_data.filter(item => item !== searchParams);
    }
    var updateData = filter_data.join('&');
    updateURLHash(updateData, collection);
    $(filter_data).each(function(i, v) {
      var urlName = v.split('=')[0];
      
      if (urlName == 'Metal' || urlName == 'Type') {
        var value = v.split('=')[1];
        url.push(value);
        if (v.indexOf('Metal') > -1) {
          color = v.split('=')[1];
        }
      }
    });
    if (window.location.href.indexOf('Metal') == -1) {
      color = '';
    }
    var updateUrl = url.join('+');
    console.log(updateUrl);
    getCollection(collection, updateUrl, color);
  });

  var pInfScrLoading = false;
  var pInfScrDelay = 100;

  function pInfScrExecute() {
    if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
      var loadingImage;
      pInfScrNode = $('.paginate').last();	
      pInfScrURL = $('.paginate a').last().attr("href");
      if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            pInfScrNode.hide();
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            var filteredData = $(data).find("#CollectionLoop").html();
            $('#CollectionLoop').append(filteredData);
            //$('button.swym-button').addClass('swym-icon swym-heart swym-loaded');
            pInfScrLoading = false;
            if(window._swat){
              window._swat.initializeActionButtons("#CollectionLoop");
            }
            var load_url = [];
            var url_data = window.location.href.split('?')[1];
            var final_data = url_data.split('&');
            var color = '';
            filter_data = final_data;
            $(final_data).each(function(i,v) {
              var value = v.split('=')[1];
              load_url.push(value);
              $('[data-tag_handlize="'+value+'"]').parent('li').addClass('active');
            });
            $(final_data).each(function(i, v) {
              if (v.indexOf('Metal') > -1) {
                color = v.split('=')[1];
              }
            });
            if (window.location.href.indexOf('Metal') == -1) {
              color = '';
            }
            setTimeout(function(){
              colorActive(color);
            }, 2000);
          },
          dataType: "html"
        });
      }
    }
  }
  $(window).scroll(function(){

    setTimeout(function(){ 
      pInfScrExecute(); 
    }, pInfScrDelay);

    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 100;
    }
  });


  $('.productDropdown').change(function () {
    var selectedOption = $(this).children('option:selected').val();
    if(selectedOption === 'Yes (I need a kit)') {
      $('#uploadery-container').hide();
    } else if (selectedOption === 'No (I already have a fingerprint)') {
      $('#uploadery-container').show();
    }        
  });


  $('.swatch-radio').click(function () {
    $('input:not(:checked)').next('.swatch-text').removeClass("display-block");
    $('input:checked').next('.swatch-text').addClass("display-block");
  }); 


  $('body').on('click','.swatch-radio',function(){
    $(this).closest('.product-list').find('.swatch-material-name').text($(this).val());
  }); 

  $('.swatch-material-name').text($('.swatch-radio').val());

  $(".right_inner_cols h5").click(function(e){
    e.preventDefault();
    if ( $(this).closest('.right_inner_cols').hasClass('active')){
      $(".right_inner_cols").removeClass("active");
      $(".right_inner_cols ul").slideUp(300);			
    } else {
      $(".right_inner_cols").removeClass("active");
      $(this).closest('.right_inner_cols').addClass('active'); 
      $(".right_inner_cols ul").slideUp(300);		
      $(".right_inner_cols.active ul").slideToggle(300);
    }
  });

  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      $(".right_inner_cols").removeClass("active");
      $(".right_inner_cols ul").slideUp(300);	
    }
  });

  // Collection page filter function start
//   $('body').on('click','.right_inner_cols.single_select ul li a',function(e){
//     e.preventDefault();
//     if($('.right_inner_cols').length){
//       e.preventDefault();
//       var arr_tags = [];
//       $(this).closest('.right_inner_cols.single_select').find('li').removeClass('active');
//       $(this).closest('li').addClass('active');
//       $('.right_inner_cols.single_select').each(function(im,vv){
//         if($(this).find('li.active').length){
//           arr_tags.push($(this).find('li.active a').attr('data-tag_handlize'));
//         }
//       });
//       arr_tags = arr_tags.join('+');
//       var col_url = '/collections/' + $('.product_quck').attr('data-col_url') + '/';
//       //         var last_url = $('.product-grid-container').attr('data-last_url');
//       var src = col_url + arr_tags;
//       window.location.href = src;
//     }
//   });
  
   
  $('body').on('click','.list_change',function(e){
    e.preventDefault(); 
    $('.list_change').removeClass('active');
    $(".right_inner_cols").removeClass("active");
    $(".right_inner_cols ul").slideUp(300);
    $(this).addClass('active');
    if($(this).hasClass('four_cols')){
      $('#CollectionLoop').addClass('four_colss');
      $('#CollectionLoop').removeClass('two_colss');
      $('#CollectionLoop').removeClass('one_colss');
    } else if ($(this).hasClass('two_cols')){
      $('#CollectionLoop').addClass('two_colss');
      $('#CollectionLoop').removeClass('four_colss');
      $('#CollectionLoop').removeClass('one_colss');
    } else if($(this).hasClass('one_cols')){
      $('#CollectionLoop').addClass('one_colss');
      $('#CollectionLoop').removeClass('four_colss');
      $('#CollectionLoop').removeClass('two_colss');
    }
  });

  if ($(window).width() < 989) {
    $('.list_change.two_cols').addClass('active');
    $('#CollectionLoop').addClass('two_colss');
  }
  
  function placeholder() {
    if ($('#order-lookup-form').length) {
      $('#orderNumber').attr('placeholder', 'Order Number*');
      $('#emailAddress').attr('placeholder', 'Your Email*');
      $('#findOrder').val('SUBMIT');
    } else {
      setTimeout(function() {
        placeholder();
      }, 300);
    }
  }
  placeholder();

  $('#input_file').change(function () {
    var file_length =  this.files.length;
    if(file_length > 0){
      $('.file_cols').addClass('active');  
    } else {
      $('.file_cols').removeClass('active');
    }
  });

});
